<template>
    <dialog-selector
        class="serviceitem-dialog-selector"
        ref="dialogSelector"
        title="选择项目"
        width="923px" 
        v-on="$listeners"
        v-bind="$attrs"
        :data="groupData"
        :props="dataProps"
        search-placeholder="输入首字母或关键字检索项目"
        :filter-node-method="filterNode"
        @click-sidebar-item="onClickSidebarItem"
        @select-change="onSelectChange">
        <template v-slot:node="{ node }" class="test">
            <div class="selector-custom-item" :class="{ 'unactive': Number(node.status) === 1 }" :title="Number(node.status) === 1 ? '已停用项目' : ''">
                <span class="selector-custom-item__name" :title="node.name">{{ node.name | cutString(20) }}</span>
                <span class="selector-custom-item__price" :title="node.itemid" v-if="!showTimes">
                    <span>￥</span>
                    {{ node.price || 0 }}
                </span>
                <span class="selector-custom-item__price" :title="node.itemid" v-else>
                    {{ node.timeStr || '' }}
                </span>
            </div>
        </template>
        <template v-slot:sidebarItem="{ menuItem }">
            <el-badge :value="countMapData[menuItem[dataProps.id]]" :max="99">
                {{ menuItem.name | cutString(10) }}
            </el-badge>
        </template>
    </dialog-selector>
</template>
<script>
    import DialogSelector from '@/components/dialog-selector';
    import UtilsMixins from '@/mixins/utils'
    export default {
        name: 'AsServiceitemDialogSelector',
        components: {
            DialogSelector,
        },
        mixins: [UtilsMixins],
        props: {
            groupData: {
                type: Array,
                default: () => []
            },
            dataProps: {
                type: Object,
                default: () => {
                    return { label: 'name', groupId: 'classid', id: 'itemid', children: 'serviceItems' }
                }
            },
            showTimes: Boolean,
        },
        data() {
            return {
                selectGroupId: null,
                countMapData: {},
            }
        },
        methods: {
            onSelectChange(groupSelectData) {
                const countMapData = {};
                Object.keys(groupSelectData).forEach(key => {
                    const length = groupSelectData[key].selectIds.length;
                    countMapData[key] = length || '';
                })
                this.countMapData = countMapData;
            },
            onClickSidebarItem(item) {
                this.selectGroupId = item ? item[this.dataProps.id] : null;
                if (this.selectGroupId === -1) this.selectGroupId = null;
                item && this.$refs.dialogSelector.filter();
            },
            filterNode(value, data) {
                if (!value) {
                    return this.selectGroupId === null || data[this.dataProps.groupId] === this.selectGroupId;
                }
                const { name } = data;
                if ( /^[a-zA-Z]+$/.test(value) && window.pinyin) {   
                    let str = window.pinyin(name, {
                        style: window.pinyin.STYLE_FIRST_LETTER
                    }).join('');
                    str = str.toLowerCase();
                    let valStr = value.toLowerCase();
                    let flag = false;
                    if (str.indexOf(valStr) !== -1) flag = true;
                    return flag;
                } 
                return name.indexOf(value) !== -1;
            },
        }
    }
</script>
<style lang="scss">
    .serviceitem-dialog-selector {
        .dialog-selector__content {
            height: 370px;
        }
        &.dialog-selector__dialog--single {
            .dialog-selector__content {
                height: 420px;
            }
        }
        .selector-custom-item {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &.unactive {
                .selector-custom-item__price,
                .dialog-selector__item, 
                .selector-custom-item__name {
                    color: #999;
                }

            }
        }
        .selector-custom-item__price {
            color: #F83051;
        }
        .dialog-selector__item {
            margin-right: 30px;
            flex: 0 0 calc(33.33% - 30px);
        }
    }
</style>